import http from '@/services/http'
import { orderBy } from 'lodash'

export default {
  namespaced: true,
  state: {
    isThreadListFetchInProgress: false,
    threads: [],
  },
  mutations: {
    startFetchThreads(state) {
      state.isThreadListFetchInProgress = true
    },
    stopFetchThreads(state) {
      state.isThreadListFetchInProgress = false
    },
    setThreads(state, threads) {
      state.threads = threads
    },
    updateThread(state, threadId, data) {
      state.threads = state.threads.map((t) => {
        if (t.id === threadId) {
          return { ...t, ...data }
        } else {
          return { ...t }
        }
      })
    },
  },

  getters: {
    unreadMessagesCount: (state) => {
      return state.threads.map((t) => t.unread_count).reduce((a, b) => a + b, 0)
    },
    threads: (state) => {
      // threads sorted by most recently active
      return orderBy(
        state.threads,
        [(t) => !!t.last_message_ts, 'last_message_ts'],
        ['desc', 'desc'],
      )
    },
  },

  actions: {
    async fetchThreads({ commit }) {
      commit('startFetchThreads')
      try {
        const response = await http.getAuthed('/chat/threads')
        commit('setThreads', response.data.threads)
        return response
      } finally {
        commit('stopFetchThreads')
      }
    },
  },
}
